<template>
    <div v-if="showModal">
        test
        <b-modal
            v-model="showModalLocal"
            :title="'Проведение платежей'"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <form @submit.prevent="someAction()" ref="forma">
                <b-tabs v-model="page">
                    <b-tab title="Провести платеж">
                        <template  v-if="page===0">
                            <b-form-group label="Тип платежа"  :state="validateState('type')"  :invalid-feedback="veeErrors.first('type')">
                                <b-select
                                    :options="getTypesForSystem"
                                    v-model="payment.type"
                                    value-field="id"
                                    text-field="title"
                                    v-validate="{required:true,}"
                                    data-vv-name="type"
                                    data-vv-as="Тип платежа"
                                    :state="validateState('type')"
                                ></b-select>
                            </b-form-group>

                            <b-form-group>
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" class="custom-control-input" id="revoke_booking_only" value="1" v-model="payment.cash" >
                                    <label class="custom-control-label" for="revoke_booking_only">Оплата наличными</label>
                                </div>
                            </b-form-group>

                            <!--b-form-group label="ИНН контрагента" :state="validateState('inn')"  :invalid-feedback="veeErrors.first('inn')">
                                <input
                                    v-model="payment.inn"
                                    v-validate="{required:true,inn:true}"
                                    data-vv-name="inn"
                                    data-vv-as="ИНН контрагента"
                                    class="form-control"
                                ></input>
                            </b-form-group-->

                            <b-form-group label="Контрагент" :state="validateState('contractor')"  :invalid-feedback="veeErrors.first('contractor')">
                                <v-select
                                    v-model="payment.contractor"
                                    :options="getCompanies()"
                                    placeholder="Выберите контрагента"
                                    v-validate="{required:true,}"
                                    label="title"
                                    data-vv-name="contractor"
                                    data-vv-as="Контрагент"
                                    :state="validateState('contractor')"
                                ></v-select>
                            </b-form-group>


                            <b-form-group label="Сумма платежа" :state="validateState('amount')"  :invalid-feedback="veeErrors.first('amount')">
                                <input
                                    v-model.number="amount"
                                    v-validate="{required:true,decimal:2,min_value:0.01}"
                                    data-vv-name="amount"
                                    data-vv-as="Сумма платежа"
                                    class="form-control"
                                ></input>
                            </b-form-group>

                            <div class="row">
                                <div class="col col-xs-6">
                                    <b-form-group label="№ платежного поручения" :state="validateState('document_number')"  :invalid-feedback="veeErrors.first('document_number')">
                                        <input
                                            v-model.number="payment.document_number"
                                            v-validate="{}"
                                            data-vv-name="document_number"
                                            data-vv-as="№ платежного поручения"
                                            class="form-control"
                                        ></input>
                                    </b-form-group>
                                </div>

                                <div class="col col-xs-6">
                                    <b-form-group label="Дата платежного поручения">
                                        <v-date-picker
                                            id="document_date"
                                            v-model='payment.document_date'
                                            :state="validateState('document_date')"
                                            :attributes="datepicker_attributes"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="document_date_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                :state="validateState('document_date')"
                                                v-bind="inputProps"
                                                v-on="inputEvents" />

                                        </v-date-picker>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-xs-6">
                                    <b-form-group label="№ банковской выписки" :state="validateState('statement_number')"  :invalid-feedback="veeErrors.first('statement_number')">
                                        <input
                                            v-model.number="payment.statement_number"
                                            v-validate="{}"
                                            data-vv-name="statement_number"
                                            data-vv-as="№ банковской выписки"
                                            class="form-control"
                                        ></input>
                                    </b-form-group>
                                </div>

                                <div class="col col-xs-6">
                                    <b-form-group label="Дата банковской выписки">
                                        <v-date-picker
                                            id="statement_date"
                                            v-model='payment.statement_date'
                                            :state="validateState('statement_date')"
                                            :attributes="datepicker_attributes"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="statement_date_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                :state="validateState('statement_date')"
                                                v-bind="inputProps"
                                                v-on="inputEvents" />

                                        </v-date-picker>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-xs-6">
                                    <b-form-group label="№ счета на оплату" :state="validateState('invoice_number')"  :invalid-feedback="veeErrors.first('invoice_number')">
                                        <input
                                            v-model.number="payment.invoice_number"
                                            v-validate="{}"
                                            data-vv-name="invoice_number"
                                            data-vv-as="№ счета на оплату"
                                            class="form-control"
                                        ></input>
                                    </b-form-group>
                                </div>

                                <div class="col col-xs-6">
                                    <b-form-group label="Дата счета на оплату">
                                        <v-date-picker
                                            id="invoice_date"
                                            v-model='payment.invoice_date'
                                            :state="validateState('invoice_date')"
                                            :attributes="datepicker_attributes"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="invoice_date_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                :state="validateState('invoice_date')"
                                                v-bind="inputProps"
                                                v-on="inputEvents" />

                                        </v-date-picker>
                                    </b-form-group>
                                </div>
                            </div>

                            <b-form-group label="Договор" :state="validateState('contract')" :invalid-feedback="veeErrors.first('contract')">
                                <input
                                    v-model="payment.contract"
                                    v-validate="{max:30}"
                                    data-vv-name="contract"
                                    data-vv-as="Договор"
                                    class="form-control"
                                ></input>
                            </b-form-group>

                            <b-form-group label="Информация о платеже" :state="validateState('info')" :invalid-feedback="veeErrors.first('info')">
                                <input
                                    v-model="payment.info"
                                    v-validate="{max:500}"
                                    data-vv-name="info"
                                    data-vv-as="Информация о платеже"
                                    class="form-control"
                                ></input>
                            </b-form-group>
                        </template>
                    </b-tab>

                    <b-tab title="Загрузить выписки">
                        <template  v-if="page===1">

                            <b-form-group lebel="XML данные">
                                <textarea v-model="to_upload.data" class="form-control"></textarea>
                            </b-form-group>

                            <b-form-group lebel="XML файл" description="файл имеет приоритет перед данными">
                                <b-form-file id="file-default" v-model='to_upload.file'
                                             placeholder="Выберите файл..."
                                             drop-placeholder="Кидать файло сюды..."
                                ></b-form-file>
                            </b-form-group>

                        </template>
                    </b-tab>
                </b-tabs>

                <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                    <b-button size="sm" variant="outline-secondary" @click="cancel()">
                        Закрыть
                    </b-button>
                    <b-button size="sm" variant="outline-success" @click="ok()" :disabled="!isFormValid">
                        Сохранить {{ isFormValid }}
                    </b-button>
                </template>
            </form>

        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import { functions_payments } from '@/functions/payments.js';
    import vSelect from 'vue-select';

    export default {
        name: 'PaymentsDialog',
        mixins: [functions, functions_loaders, functions_company, functions_payments],
        components: { vSelect },
        data: function () {
            return {
                payment: {
                    type:null,
                    contractor:null,
                    amount:null,
                    cash:false,
                    document_number:null,
                    document_date:null,
                    statement_number:null,
                    statement_date:null,
                    invoice_number:null,
                    invoice_date:null,
                    contract:null,
                    info:null,
                },
                to_upload: {
                    data: null,
                    file: null,
                },
                page: null,
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
        },
        watch: {
        },
        methods: {
            send_form: function() {
                this.$validator.validateAll().then((result) => {
                        console.log('result=',result)
                        if (!result) return false;
                        if (this.page === 0) {
                            this.createPayment(this.payment, function (self) {
                                self.$emit("hide", false);
                                self.$emit("payment_created", true);
                            }, this);
                        } else {
                            this.uploadPayments(this.to_upload, function (self) {
                                self.$emit("hide", false);
                                self.$emit("payment_uploaded", self.upload_result);
                            }, this);
                        }

                        return true;
                    }, (error) => {
                        console.log('error=',error)
                    }
                ).catch(()=>{
                    console.log('catch')
                });
            },
            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.send_form();
            },
            handleSubmit: function () {
                this.send_form();
            },
            someAction: function() {
                alert('go-go');
            },
            getCompanies: function() {
                return this.companies;
            }
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },
            isFormValid () {
                console.log('isFormValid1');
                console.log(this.$refs.forma);
                if (!this.$refs.forma) return false;
                console.log('isFormValid2');
                console.log(this.$refs.forma.fields);
                if (!this.$refs.forma.fields) return false;
                console.log('isFormValid3');
                return Object.keys(this.$refs.forma.fields).every(field => this.$refs.forma.fields[field].valid);
            },
            amount: {
                set: function (val) {
                    //this.company.credit_limit =val;
                    this.payment.amount = Math.round(val*100);
                },
                get: function () {
                    //return this.company.credit_limit;
                    return this.payment.amount/100;
                },
            },
        },
        created: function() {
            this.loadCompanies();
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            //console.log('SimpleDialog: updated');
        },
    }
</script>
